import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const PaymentOk = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const processPayment = async () => {
      try {
        const merchantPacket = searchParams.get("MerchantPacket");
        const bankPacket = searchParams.get("BankPacket");
        const sign = searchParams.get("Sign");
        const orderId = searchParams.get("orderId");

        if (!merchantPacket || !bankPacket || !sign || !orderId) {
          throw new Error("Eksik parametreler");
        }

        // 1. MAC Doğrulama
        const macVerifyResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/payment/verify-mac`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              merchantPacket,
              bankPacket,
              sign,
              orderId,
            }),
          }
        );

        const macData = await macVerifyResponse.json();

        if (!macData.success) {
          throw new Error(macData.message);
        }

        const {
          mdStatus,
          txStatus,
          bankPacket: validatedBankPacket,
        } = macData.data;

        // mdStatus kontrolü
        if (mdStatus !== "1") {
          throw new Error(
            "3D Secure doğrulama başarısız. mdStatus: " + mdStatus
          );
        }

        // 2. Finansallaştırma
        const finalizeResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/payment/finalize-payment`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              orderId,
              bankData: validatedBankPacket,
            }),
          }
        );

        const finalizeData = await finalizeResponse.json();

        if (!finalizeData.success) {
          throw new Error(finalizeData.message);
        }

        setResult(finalizeData);
        setIsProcessing(false);

        // 5 saniye sonra login sayfasına yönlendir
        setTimeout(() => {
          navigate("/login");
        }, 5000);
      } catch (err) {
        console.error("Payment processing error:", err);
        setError(err.message || "Ödeme işlemi başarısız");
        setIsProcessing(false);

        // 3 saniye sonra ana sayfaya yönlendir
        setTimeout(() => {
          navigate("/");
        }, 3000);
      }
    };

    processPayment();
  }, [searchParams, navigate]);

  if (isProcessing) {
    return (
      <div
        style={{
          maxWidth: "600px",
          margin: "100px auto",
          padding: "40px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "60px",
            height: "60px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #10b981",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px",
          }}
        />
        <h2 style={{ color: "#374151", marginBottom: "10px" }}>
          Ödemeniz İşleniyor...
        </h2>
        <p style={{ color: "#64748b" }}>Lütfen bekleyin, sayfayı kapatmayın.</p>

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          maxWidth: "600px",
          margin: "100px auto",
          padding: "40px",
          background: "#fee",
          borderRadius: "20px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "60px", marginBottom: "20px" }}>❌</div>
        <h2 style={{ color: "#c00", marginBottom: "15px" }}>Ödeme Başarısız</h2>
        <p style={{ color: "#991b1b", marginBottom: "25px" }}>{error}</p>
        <p style={{ color: "#64748b", fontSize: "14px" }}>
          3 saniye sonra ana sayfaya yönlendirileceksiniz...
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "100px auto",
        padding: "40px",
        background: "#dcfce7",
        borderRadius: "20px",
        textAlign: "center",
      }}
    >
      <CheckCircle
        size={80}
        style={{ color: "#10b981", margin: "0 auto 20px" }}
      />
      <h1 style={{ color: "#065f46", marginBottom: "15px" }}>
        Ödeme Başarılı! 🎉
      </h1>
      <p style={{ color: "#047857", fontSize: "18px", marginBottom: "30px" }}>
        Kaydınız tamamlandı. Hesabınız aktif edildi.
      </p>

      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "12px",
          marginBottom: "25px",
          textAlign: "left",
        }}
      >
        <div style={{ marginBottom: "10px" }}>
          <strong>Onay Kodu:</strong> {result?.data?.authCode}
        </div>
        <div>
          <strong>Referans No:</strong> {result?.data?.hostlogkey}
        </div>
      </div>

      <p style={{ color: "#047857", fontSize: "14px" }}>
        5 saniye sonra giriş sayfasına yönlendirileceksiniz...
      </p>
    </div>
  );
};

export default PaymentOk;
